import * as React from "react";

type UseDismissTimerOptions = {
  durationMs: number;
  isPaused: boolean;
  isDisabled: boolean;
  onExpire: () => void;
};

export const useDismissTimer = ({
  durationMs,
  isPaused,
  isDisabled,
  onExpire,
}: UseDismissTimerOptions): void => {
  const remainingMs = React.useRef(durationMs);
  const onExpireRef = React.useRef(onExpire);

  React.useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  React.useEffect(() => {
    if (isPaused || isDisabled) return;

    const startedAt = Date.now();
    const timeoutId = window.setTimeout(
      () => onExpireRef.current(),
      remainingMs.current,
    );

    return () => {
      window.clearTimeout(timeoutId);
      remainingMs.current = Math.max(
        0,
        remainingMs.current - (Date.now() - startedAt),
      );
    };
  }, [isDisabled, isPaused]);
};
